export { default as SocialButton } from "./SocialButton";
